import React, { useState } from "react";
import styles from "./CardFrameWithTabs.module.scss";

export interface CardFrameTab {
	title: string;
	content: React.ReactNode;
}

interface CardFrameWithTabsProps {
	tabs: CardFrameTab[];
}

export const CardFrameWithTabs: React.FC<CardFrameWithTabsProps> = ({ tabs }) => {
	const [selectedIndex, setSelectedIndex] = useState(0);

	return (
		<div className={styles.card}>
			<div className={styles.tabRow}>
				{tabs.map((tab, i) => (
					<button key={tab.title} className={`${styles.tab} ${i === selectedIndex ? styles.tabActive : ""}`} onClick={() => setSelectedIndex(i)}>
						{tab.title}
					</button>
				))}
			</div>
			{tabs[selectedIndex]?.content}
		</div>
	);
};
